module.exports = __webpack_public_path__ + "static/media/actions-bg.6de11011.svg";